// extracted by mini-css-extract-plugin
export default {"page":"styles_page__JLUei","main":"styles_main__e-KAf","col":"styles_col__WGW0y","btn":"styles_btn__HDJX0"};